module.exports = __webpack_public_path__ + "img/prize_1.5d3f7abb.png";